import axios from "axios";

export const trackVisit = async (user, page) => {
  try {
    const res = await axios.post("/analytics/track", {
      userId: user?._id,
      isLoggedIn: !!user,
      page,
    });
  } catch (error) {
    console.error("Failed to track visit:", error.message);
  }
};
